<div *ngFor="let messageObj of messages">
    <cart-info-message [messageObj]="messageObj" (removeMessage)="removeMessage(messageObj)" *ngIf="messageObj && messageObj.show"></cart-info-message>
</div>
